import React, { useEffect } from 'react';
import PageWayfinding from '../../components/common/PageWayfinding';
import About from './About';
import './About.css';

const AboutPage = () => {
  useEffect(() => {
    document.title = 'marketDir — Обо мне';
  }, []);

  return (
    <main className="about-page-shell">
      <PageWayfinding />
      <About />
    </main>
  );
};

export default AboutPage;
